import React from 'react';

/**
 * Circulo con un icono IconKit dentro. Tono: 'surface' (por defecto), 'accent',
 * 'success', 'warn', 'danger', 'totp'. Usado en FeatureBanner, EmptyState, listas.
 */
function IconCircle({ icon: Icon, tone = 'surface', size = 40, className = '', ...rest }) {
  return (
    <span
      className={`sgc-icon-circle sgc-icon-circle--${tone} ${className}`}
      style={{ width: size, height: size }}
      {...rest}
    >
      {Icon && <Icon width={Math.round(size * 0.5)} height={Math.round(size * 0.5)} aria-hidden="true" />}
    </span>
  );
}

export default IconCircle;
